import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BankingService } from '../../../features/banking/services/banking.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker';

@Component({
  selector: 'add-transaction-dialog',
  templateUrl: './add-transaction-dialog.html',
  styleUrls: ['./add-transaction-dialog.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepicker,
    MatDatepickerModule,
  ],
})
export class AddTransactionDialog {
  addTransactionForm: FormGroup;
  accounts: any;
  search: string;
  currentBankId: any;
  currentBankName: any;
  transactionCategories: any;
  paidViaOptions: string[] = ['cash', 'cheque', 'card', 'upi'];
  showPaidVia = false;


  constructor(
    private bankingService: BankingService,
    private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<AddTransactionDialog>,
    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: { bankId: number }
  ) {}

  ngOnInit() {
    
    this.fetcBankAccounts();
    this.addTransactionForm = this.fb.group({
      type: [null, Validators.required],
      account: [null, Validators.required],
      amount: [null, [Validators.required, Validators.min(1)]],
      transactionCategory: [null, Validators.required],
      transactionDate: [null, Validators.required],
      description: ['', Validators.required],
      referenceNumber: ['', Validators.required],
      paidVia: [null],
    });

    this.addTransactionForm.get('type')?.valueChanges.subscribe((val) => {
      if (val === 'IN') {
        this.getTransactionCategories('in');
      } else if (val === 'OUT') {
        this.getTransactionCategories('out');
      }
    });

    this.addTransactionForm.get('transactionCategory')?.valueChanges.subscribe((val) => {
      if (val === 'other income' || val === 'owner contribution') {
        this.showPaidVia = true;
        this.addTransactionForm.get('paidVia')?.setValidators([Validators.required]);
      } else {
        this.showPaidVia = false;
        this.addTransactionForm.get('paidVia')?.clearValidators();
        this.addTransactionForm.get('paidVia')?.setValue(null);
      }
      this.addTransactionForm.get('paidVia')?.updateValueAndValidity();
    });
  }


  allowOnlyNumberWithDecimal(event: KeyboardEvent): void {
    const inputChar = String.fromCharCode(event.keyCode || event.which);

    // Allow digits and decimal point
    if (!/^[0-9.]$/.test(inputChar)) {
      event.preventDefault();
      return;
    }

    // Disallow more than one decimal point
    const input = event.target as HTMLInputElement;
    if (inputChar === '.' && input.value.includes('.')) {
      event.preventDefault();
    }
  }

  blockPaste(event: ClipboardEvent): void {
    const pastedInput: string = event.clipboardData?.getData('text') || '';
    if (!/^\d*\.?\d*$/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  fetcBankAccounts() {
    this.currentBankId = this.data?.bankId;

    this.bankingService.listAllBankAccounts('').subscribe({
      next: (res) => {
        this.accounts = res;
        const account = this.accounts.find(
          (acc: any) => acc.id === this.currentBankId
        );
        if (account) {
          this.currentBankName = account.bankName;
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getTransactionCategories(direction: any) {
    this.bankingService.transactionCategories(direction).subscribe({
      next: (res) => {
        this.transactionCategories = res;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  onAddTransaction() {
    if (this.addTransactionForm.invalid) {
      this.addTransactionForm.markAllAsTouched();
      return;
    }
    const formValue = this.addTransactionForm.value;
    const createBankTransactionInput = {
      bankAccountId: Number(this.currentBankId),
      transactionType: formValue.type === 'IN' ? 'Credit' : 'Debit',
      amount: parseFloat(formValue.amount),
      counterAccountId: Number(formValue.account),
      transactionDate: formValue.transactionDate,
      description: formValue.description,
      referenceNumber: formValue.referenceNumber,
      transactionCategory: formValue.transactionCategory,
      ...(formValue.paidVia ? { paidVia: formValue.paidVia } : {})
    };

    this.bankingService
      .createBankTransaction(createBankTransactionInput)
      .subscribe({
        next: (res) => {
          console.log(res);
          this.toastr.success("Transaction successfully added");
          this.dialogRef.close();
        },
        error: (err) => {
          this.toastr.error(err?.message)
          console.log(err);
        },
      });
  }
}